module.exports = "<ng-template [ngTemplateOutlet]=\"templates[templateKey]\" [ngTemplateOutletContext]=\"{}\">\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal/catalog-modal/catalog-template-host.component.html
// module id = ./src/app/shared/components/modal/catalog-modal/catalog-template-host.component.html
// module chunks = main